import { view_route } from "data/Spec";

import DomainSearchBox from "./DomainSearchBox.js";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import React from "react";

function ListView() {
  const intl = useIntl();
  const { listType } = useParams();
  if (view_route[listType]) {
    let v = view_route[listType];
    var title = intl.formatMessage({ id: v.title_id });
    return <DomainSearchBox ltype={listType} title={title} />;
  }
  return (
    <div>not support</div>
  );
}
export default ListView;
